/* Navbar: expandir búsqueda (desktop underline / mobile barra pill + volver) */
(function () {
    const wraps = document.querySelectorAll('[data-melo-nav-search]');
    if (!wraps.length) {
        return;
    }

    const mobileMq = window.matchMedia('(max-width: 991px)');

    function setSearchActive(active) {
        const navigation = document.getElementById('gh-navigation');
        if (navigation) {
            navigation.classList.toggle('melo-nav-search-active', active);
        }
        document.documentElement.classList.toggle('melo-nav-search-active', active);
    }

    wraps.forEach(function (wrap) {
        const openBtn = wrap.querySelector('[data-melo-nav-search-open]');
        const backBtn = wrap.querySelector('[data-melo-nav-search-back]');
        const form = wrap.querySelector('.melo-nav-search-form');
        const input = form ? form.querySelector('input[name="q"]') : null;
        const closeBtn = wrap.querySelector('[data-melo-nav-search-close]');

        if (!openBtn || !form || !input) {
            return;
        }

        function expand() {
            wrap.classList.add('is-expanded');
            openBtn.setAttribute('aria-expanded', 'true');
            form.setAttribute('aria-hidden', 'false');
            if (backBtn) {
                backBtn.hidden = false;
            }
            if (mobileMq.matches) {
                setSearchActive(true);
            }
            window.requestAnimationFrame(function () {
                input.focus();
            });
        }

        function collapse() {
            wrap.classList.remove('is-expanded');
            openBtn.setAttribute('aria-expanded', 'false');
            form.setAttribute('aria-hidden', 'true');
            input.value = '';
            if (backBtn) {
                backBtn.hidden = true;
            }
            setSearchActive(false);
        }

        openBtn.addEventListener('click', function (event) {
            event.stopPropagation();
            if (wrap.classList.contains('is-expanded')) {
                input.focus();
                return;
            }
            expand();
        });

        if (backBtn) {
            backBtn.addEventListener('click', function (event) {
                event.stopPropagation();
                collapse();
                openBtn.focus();
            });
        }

        if (closeBtn) {
            closeBtn.addEventListener('click', function (event) {
                event.stopPropagation();
                collapse();
                openBtn.focus();
            });
        }

        input.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                event.preventDefault();
                collapse();
                openBtn.focus();
            }
        });

        form.addEventListener('click', function (event) {
            event.stopPropagation();
        });

        document.addEventListener('click', function (event) {
            if (mobileMq.matches || !wrap.classList.contains('is-expanded')) {
                return;
            }
            if (wrap.contains(event.target)) {
                return;
            }
            collapse();
        });

        form.addEventListener('submit', function (event) {
            const value = input.value.trim();
            if (!value) {
                event.preventDefault();
                input.focus();
            }
        });
    });

    mobileMq.addEventListener('change', function () {
        if (!mobileMq.matches) {
            setSearchActive(false);
        }
    });
})();
